import Outline from './Outline';

export default Outline;
